module.exports = __webpack_public_path__ + "fa3c12c1cad33df17ad22e7f49af4e8c.pdf";